import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Reportselect from "./Reportselect";
import { subDays, startOfMonth, endOfMonth, subMonths, format } from "date-fns";
import DatePicker from "react-datepicker";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import {
  dateRangeOptions,
  formatToIndianNumber,
  formatToNumber,
  paymentMethodBadge,
  paymentStatusBadge,
} from "../../utilities";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import {
  getBillingReportApi,
  getBillingReportExportApi,
  getExpenseReportApi,
  getExpenseReportExportApi,
} from "../../services/ReportService";
import { toast } from "react-toastify";
import { getServiceCenterOptionApi } from "../../services/SearchService";
import { Spinner } from "react-bootstrap";
import { BiSolidDiscount, BiSolidFileExport } from "react-icons/bi";
import { CustomTooltip } from "../../components/CustomTooltip";
import {
  FaAdjust,
  FaDownload,
  FaFileInvoiceDollar,
  FaInfo,
  FaInfoCircle,
  FaMoneyBillWave,
  FaRupeeSign,
} from "react-icons/fa";
import { IoInformationCircleSharp } from "react-icons/io5";
import Pagination from "../Constant/Pagination";
const BillAndExpenseReport = () => {
  const [selectedDate, setSelectedDate] = useState(dateRangeOptions[0]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selecetdServiceCenter, setSelecetdServiceCenter] = useState(null);
  const [serviceCenterOption, setServiceCenterOption] = useState([]);
  //billing
  const [billingData, setBillingData] = useState(null);
  const [billingTotal, setBillingTotal] = useState(0);
  const [billingLoading, setBillingLoading] = useState(false);
  const [billingExportLoading, setBillingExportLoading] = useState(false);
  const [billingParam, setBillingParam] = useState({
    query: "",
    page: "1",
    page_size: "6",
  });

  //expense
  const [expenseData, setExpenseData] = useState(null);
  const [expenseTotal, setExpenseTotal] = useState(0);
  const [expenseLoading, setExpenseLoading] = useState(false);
  const [expenseExportLoading, setExpenseExportLoading] = useState(false);
  const [expenseParam, setExpenseParam] = useState({
    query: "",
    page: "1",
    page_size: "6",
  });
  const [param, setParam] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });

  const getServiceCenter = () => {
    getServiceCenterOptionApi()
      .then((res) => {
        const option = res?.data?.results || [];
        setServiceCenterOption(option);
        setSelecetdServiceCenter(option[0]);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getBilling = () => {
    setBillingLoading(true);
    getBillingReportApi(selecetdServiceCenter?.value || "", {
      ...param,
      ...billingParam,
    })
      .then((res) => {
        setBillingData(res?.data?.results);
        setBillingTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setBillingLoading(false);
      });
  };

  const getExpense = () => {
    setExpenseLoading(true);
    getExpenseReportApi(selecetdServiceCenter?.value || "", {
      ...param,
      ...expenseParam,
    })
      .then((res) => {
        setExpenseData(res?.data?.results);
        setExpenseTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExpenseLoading(false);
      });
  };

  useEffect(() => {
    getServiceCenter();
  }, []);

  useEffect(() => {
    if (selecetdServiceCenter?.value) {
      getBilling();
    }
  }, [billingParam, param, selecetdServiceCenter]);

  useEffect(() => {
    if (selecetdServiceCenter?.value) {
      getExpense();
    }
  }, [expenseParam, param, selecetdServiceCenter]);
  const handleDateRangeChange = (option) => {
    setSelectedDate(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
        page: "1",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "today":
        startDate = new Date();
        endDate = new Date();
        break;
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  //billing-search pagination
  const handleBillingPageChange = (page) => {
    setBillingParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleBillingSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setBillingParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  //expense-search pagination
  const handleExpensePageChange = (page) => {
    setExpenseParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleExpenseSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setExpenseParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleBillingExport = () => {
    setBillingExportLoading(true);
    getBillingReportExportApi(selecetdServiceCenter?.value || "", {
      ...param,
      ...billingParam,
      export: true,
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Billing-report.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setBillingExportLoading(false);
      });
  };

  const handleExpenseExport = () => {
    setExpenseExportLoading(true);
    getExpenseReportExportApi(selecetdServiceCenter?.value || "", {
      ...param,
      ...expenseParam,
      export: true,
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Expense-report.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExpenseExportLoading(false);
      });
  };
  return (
    <div>
      {/* <div className="card mb-3">
        <div className="d-flex justify-content-between align-items-start gap-2 flex-start p-3 flex-wrap">
          <div className="d-flex flex-column">
            <h5 className="mb-0">Billing & Expense Report</h5>
            <span
              className="text-dark fw-medium"
              style={{ fontSize: "0.8rem" }}
            >
              Manage your payments
            </span>
          </div>
          <div className="d-flex gap-2">
            <div>
              <Reportselect />
            </div>
          </div>
        </div>
        <div className="row g-3 py-2 px-3">
          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
           
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
           
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                      boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaRupeeSign size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.8rem", color: "#1e3a8a" }}
                  >
                    Availabe Cash
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(0)}
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(236, 72, 153, 0.15), rgba(251, 207, 232, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(236, 72, 153, 0.12), rgba(251, 207, 232, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ec4899, #f9a8d4)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #ec4899, #f9a8d4)",
                      boxShadow: "0 4px 10px rgba(236, 72, 153, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaRupeeSign size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.8rem", color: "#1e3a8a" }}
                  >
                    Pettycash
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(0)}
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                      boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <BiSolidDiscount size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Total Expenses
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(0)}
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #22c55e, #86efac)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #22c55e, #86efac)",
                      boxShadow: "0 4px 10px rgba(34, 197, 94, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaMoneyBillWave size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.8rem", color: "#1e3a8a" }}
                  >
                    Total Sell
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(0)}
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ef4444, #f87171)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #ef4444, #f87171)",
                      boxShadow: "0 4px 10px rgba(239, 68, 68, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaFileInvoiceDollar size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.8rem", color: "#1e3a8a" }}
                  >
                    Paid
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(0)}
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #eab308, #fde047)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #eab308, #fde047)",
                      boxShadow: "0 4px 10px rgba(234, 179, 8, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaAdjust size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.8rem", color: "#1e3a8a" }}
                  >
                    Partially Paid
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(0)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="d-flex justify-content-between flex-wrap gap-2 mb-3">
        <div>
          <span
            className="text-primary"
            style={{ fontSize: "1.3rem", fontWeight: "500" }}
          >
            Billing & Expense Report
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Report
            </li>
          </ol>
        </div>
        <div className="d-flex gap-2 justify-content-center align-items-center">
          <div>
            <Reportselect />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between gap-1 flex-wrap px-3 py-2 py-md-0 align-items-center">
          <div className="d-flex flex-column">
            <span className="text-darker fw-medium fs-6">
              Total Billing:{" "}
              <span className="d-inline-flex gap-1 align-items-center">
                ₹{formatToIndianNumber(billingData?.summary?.received_total)}
                <CustomTooltip
                  title={
                    <div>
                      <div>
                        <strong>Cash:</strong>₹
                        {formatToIndianNumber(
                          billingData?.summary?.received_by_method?.CASH
                        )}
                      </div>
                      <div>
                        <strong>Card:</strong>₹
                        {formatToIndianNumber(
                          billingData?.summary?.received_by_method?.CARD
                        )}
                      </div>
                      <div>
                        <strong>UPI Business:</strong>₹
                        {formatToIndianNumber(
                          billingData?.summary?.received_by_method?.[
                            "UPI BUSINESS"
                          ]
                        )}
                      </div>
                      <div>
                        <strong>UPI Personal:</strong>₹
                        {formatToIndianNumber(
                          billingData?.summary?.received_by_method?.[
                            "UPI PERSONAL"
                          ]
                        )}
                      </div>
                    </div>
                  }
                  placement="right"
                >
                  <span
                    className="rounded-3 btn btn-sm btn-dark"
                    style={{
                      cursor: "pointer",
                      padding: "0.15rem 0.15rem",
                    }}
                  >
                    <FaInfo size={7} className="text-white" />
                  </span>
                </CustomTooltip>
              </span>
            </span>
            <span className="text-darker fw-medium fs-6">
              Total Expense:{" "}
              <span className="text-danger">
                ₹{formatToIndianNumber(expenseData?.summary?.paid_total)}
              </span>
            </span>
          </div>
          <div className="d-flex gap-2 justify-content-start justify-content-md-end py-1 py-md-4 flex-wrap gap-2">
            <div>
              <GlobalSearchableDropdown
                options={serviceCenterOption}
                selected={selecetdServiceCenter}
                onSelect={setSelecetdServiceCenter}
                placeholder="Service center"
                isClearable={false}
              />
            </div>

            {showDatePicker && (
              <div className="">
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                />
              </div>
            )}
            <div className="">
              <GlobalSearchableDropdown
                options={dateRangeOptions}
                selected={selectedDate}
                onSelect={(item) => handleDateRangeChange(item)}
                placeholder="Period"
              />
            </div>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-md-6">
            <div className="card h-100">
              <div className="p-3 d-flex justify-content-between gap-2 align-items-center">
                <h5>Billing Summary</h5>
                <div className="d-flex gap-1">
                  <div className="">
                    <DebounceSmallSearchInput
                      handleSearchChange={handleBillingSearchChange}
                    />
                  </div>
                  <div>
                    <CustomTooltip title="Export">
                      <button
                        className="btn btn-success"
                        style={{ padding: "0.65rem 0.6rem" }}
                        onClick={handleBillingExport}
                        disabled={
                          billingExportLoading ||
                          billingData?.details?.length == 0
                        }
                      >
                        {billingExportLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <FaDownload size="16" />
                        )}
                      </button>
                    </CustomTooltip>
                  </div>
                </div>
              </div>
              <div>
                {billingLoading ? (
                  <div className="text-center my-4">
                    <Spinner animation="border" />
                  </div>
                ) : billingData?.details && billingData?.details?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table fs-6 mb-0 align-middle">
                      <thead className="table-light custom-thead">
                        <tr>
                          <th>Invoice</th>
                          <th>Total</th>
                          <th>Paid Amount</th>
                          <th>Payment Status</th>
                          <th>Payment Method</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billingData?.details?.map((item, index) => (
                          <tr
                            key={item.id}
                            style={
                              item?.is_free_service
                                ? { backgroundColor: "rgba(220, 53, 69, 0.05)" }
                                : {}
                            }
                          >
                            <td>
                              <div className="d-flex gap-1 align-items-center">
                                <span className="text-primary fw-medium cursor-pointer">
                                  {item?.invoice_id || "-"}
                                </span>

                                <CustomTooltip
                                  title={
                                    <div>
                                      <div>
                                        <strong>Vehicle Number:</strong>{" "}
                                        {item?.vehicle_number || "-"}
                                      </div>
                                      <div>
                                        <strong>Service Type:</strong>{" "}
                                        {item?.service_types || "-"}
                                      </div>
                                      <div>
                                        <strong>Customer Name:</strong>{" "}
                                        {item.customer_name || "-"}
                                      </div>
                                      <div>
                                        <strong>Customer Contact:</strong>{" "}
                                        {item?.customer_contact || "-"}
                                      </div>
                                    </div>
                                  }
                                  placement="right"
                                >
                                  <span
                                    className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                    style={{
                                      cursor: "pointer",
                                      padding: "0.2rem 0.2rem",
                                    }}
                                  >
                                    <FaInfo size={9} className="text-dark" />
                                  </span>
                                </CustomTooltip>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex gap-1 align-items-center">
                                <span className="text-darker fw-medium cursor-pointer">
                                  {item?.subtotal
                                    ? `₹${formatToIndianNumber(item?.subtotal)}`
                                    : "0"}
                                </span>

                                <CustomTooltip
                                  title={
                                    <div>
                                      <div>
                                        <strong>Tips:</strong>{" "}
                                        {item?.tips
                                          ? `₹${formatToIndianNumber(
                                              item?.tips
                                            )}`
                                          : "0"}
                                      </div>
                                      <div>
                                        <strong>Discount:</strong>{" "}
                                        {item?.discount
                                          ? `₹${formatToIndianNumber(
                                              item?.discount
                                            )}`
                                          : "0"}
                                      </div>
                                    </div>
                                  }
                                  placement="right"
                                >
                                  <span
                                    className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                    style={{
                                      cursor: "pointer",
                                      padding: "0.2rem 0.2rem",
                                    }}
                                  >
                                    <FaInfo size={9} className="text-dark" />
                                  </span>
                                </CustomTooltip>
                              </div>
                            </td>

                            <td>
                              {item?.payment_status == "PARTIALLY_PAID"
                                ? `₹${formatToIndianNumber(
                                    item?.partial_amount || 0
                                  )}`
                                : item?.payment_status == "PAID"
                                ? `₹${formatToIndianNumber(item?.total || 0)}`
                                : 0}
                            </td>
                            <td>
                              {item?.is_free_service ? (
                                <span className="badge text-bg-info-soft rounded-pill">
                                  Free
                                </span>
                              ) : (
                                paymentStatusBadge(item?.payment_status)
                              )}
                            </td>
                            <td>
                              {item?.payment_method
                                ? paymentMethodBadge(item?.payment_method)
                                : "-"}
                            </td>
                            <td>
                              {item?.date
                                ? format(new Date(item?.date), "dd MMM yyy")
                                : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center my-4">No data found</div>
                )}
                {!billingLoading && billingData?.details?.length > 0 && (
                  <div className="p-3">
                    <Pagination
                      currentPage={billingParam.page}
                      recordsPage={billingParam.page_size}
                      dataLength={billingTotal}
                      handlePagination={handleBillingPageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card h-100">
              {" "}
              <div className="p-3 d-flex justify-content-between gap-2 align-items-center">
                <h5>Expense Summary</h5>
                <div className="d-flex gap-1">
                  <div className="">
                    <DebounceSmallSearchInput
                      handleSearchChange={handleExpenseSearchChange}
                    />
                  </div>
                  <div>
                    <CustomTooltip title="Export">
                      <button
                        className="btn btn-success"
                        style={{ padding: "0.65rem 0.6rem" }}
                        onClick={handleExpenseExport}
                        disabled={
                          expenseExportLoading ||
                          expenseData?.details?.length == 0
                        }
                      >
                        {expenseExportLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <FaDownload size="16" />
                        )}
                      </button>
                    </CustomTooltip>
                  </div>
                </div>
              </div>
              <div>
                {expenseLoading ? (
                  <div className="text-center my-4">
                    <Spinner animation="border" />
                  </div>
                ) : expenseData?.details && expenseData?.details?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table fs-6 mb-0 align-middle">
                      <thead className="table-light custom-thead">
                        <tr>
                          <th>Category</th>
                          <th>Vendor</th>
                          {/* <th>Description</th> */}
                          <th>Amount</th>
                          <th>Paid Amount</th>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {expenseData?.details?.map((item, index) => (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex gap-1 align-items-center">
                                <span className="text-primary fw-medium cursor-pointer">
                                  {item?.category || "-"}
                                </span>

                                <CustomTooltip
                                  title={
                                    <div>
                                      <div>
                                        <strong>Sub Category:</strong>{" "}
                                        {item?.subcategory || "-"}
                                      </div>
                                    </div>
                                  }
                                  placement="right"
                                >
                                  <span
                                    className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                    style={{
                                      cursor: "pointer",
                                      padding: "0.2rem 0.2rem",
                                    }}
                                  >
                                    <FaInfo size={9} className="text-dark" />
                                  </span>
                                </CustomTooltip>
                              </div>
                            </td>

                            <td>{item?.vendor || "-"}</td>
                            {/* <td>{item?.description || "-"}</td> */}

                            <td>
                              {item?.amount
                                ? `₹${formatToIndianNumber(item?.amount)}`
                                : "-"}
                            </td>
                            <td>
                              {item?.paid_amount
                                ? `₹${formatToIndianNumber(item?.paid_amount)}`
                                : "-"}
                            </td>
                            <td>{paymentStatusBadge(item?.payment_status)}</td>

                            <td>
                              {item?.date
                                ? format(new Date(item?.date), "dd MMM yyy")
                                : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center my-4">No data found</div>
                )}
                {!expenseLoading && expenseData?.details?.length > 0 && (
                  <div className="p-3">
                    <Pagination
                      currentPage={expenseParam.page}
                      recordsPage={expenseParam.page_size}
                      dataLength={expenseTotal}
                      handlePagination={handleExpensePageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillAndExpenseReport;
